//@ts-nocheck
import * as actionTypes from '../actions/actionTypes';

export const storeHistory = step => ({
  type: actionTypes.STORE_HISTORY,
  step,
});
